<template>
  <div class="ViewCount">
    <el-row :gutter="20">
      <el-col :xs="24" :span="6">
        <el-card  style="min-height: auto; text-align: center; border: none">
          <h4>Marketplaces Migrados</h4>
          <i class="el-icon-user-solid"></i>
          <strong class="countMarketplaceMigrated">{{ valuesTable.countMarketplaceMigrated}}</strong>
        </el-card>
      </el-col>
      <el-col :xs="24" :span="6">
        <el-card style="min-height: auto; text-align: center; border: none">
          
          <h4>Faltam Migrar</h4>
          <i class="el-icon-user "></i>
          <strong class="countMarketplaceMissing">{{ valuesTable.countMarketplaceMissing}}</strong>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getCountMarketplaceV1 } from "@/app/domains/Config/services";
export default {
  name: "ViewCount",
  data() {
    return {
      loadingPage: true,
      valuesTable: {
        countMarketplaceMigrated: 0,
        countMarketplaceMissing: 0,
      },
    };
  },
  methods: {
  init() {
      this.listValues();
    },
    async listValues(query = "") {
      this.loadingPage = true;
      try {
        let response = await getCountMarketplaceV1(query);
        this.valuesTable = response;
      } catch (e) {
        this.$message({
          showClose: true,
          message: "Erro ao carregar Contagem",
          type: "error",
        });
      } finally {
        this.loadingPage = false;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>